import { render, staticRenderFns } from "./CycleCancelPolicySitecore.vue?vue&type=template&id=37b150c4"
import script from "./CycleCancelPolicySitecore.vue?vue&type=script&lang=js"
export * from "./CycleCancelPolicySitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports